import React, { ReactElement } from 'react';
import styles from '../MainView.module.css';
import CarerTabs from './CarerTabs';
import { CareViewProps } from './types';

const CarerView = ({
  onDoctorClick,
  onNurseClick,
  showNurse,
  showDoctor,
}: CareViewProps) => {
  return (
    <>
      <div className={styles.careTypeTabs}>
        <CarerTabs
          showNurse={showNurse}
          showDoctor={showDoctor}
          onNurseClick={onNurseClick}
          onDoctorClick={onDoctorClick}
        />
      </div>
    </>
  );
};

export default CarerView;
